import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {Field, FieldConfig} from '../../models';
import {SubSink} from '@Common/core/utils/subsink';
import {Constants} from '../../form-builder/common/constants';
import {finalize} from 'rxjs/operators';
import {EntiteService} from '@Services/entite/entite.service';
import {Entite} from '@Services/entite/entite.model';
import { constantes } from 'app/demat/common/constantes';


@Component({
  selector: 'app-form-render-svccmp',
  templateUrl: './form-render-svccmp.component.html',
  styleUrls: ['./form-render-svccmp.component.scss']
})
export class FormRenderSvccmpComponent implements OnInit, OnChanges, OnDestroy {
  @Input() formGroup: UntypedFormGroup;
  @Input() item: Field;
  fieldConfig: FieldConfig;
  blockFormName: String;
  nullValues: any = Constants.FieldsNullValues;
  listSvcCmp: Entite[];
  loading = false;
  subSink = new SubSink();
  extraParams: Map<string, string> = new Map<string, string>();
  constantes = constantes;

  constructor(private entiteSvc: EntiteService) { }

  ngOnInit(): void {
    this.blockFormName = `block-${this.item.block}`;
  }

  private _fetchSvcCmp(config: FieldConfig) {
    this.loading = true;
    const type = config.entite.toString();
    this.extraParams.set('application', constantes.application.toString());
    if (type !== '3') {
      this.extraParams.set('type', type);
    }
    this.subSink.sink = this.entiteSvc.listAllItems(this.extraParams)
      .pipe(finalize(() => this.loading = false))
      .subscribe(
      (_data) => {
        this.listSvcCmp = _data.list;
        this.entiteSvc.sortBy(this.listSvcCmp);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.item?.currentValue) {
      this.fieldConfig = changes?.item?.currentValue.options_obj;
      this._fetchSvcCmp(this.fieldConfig);
    }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
